export const CONNECTION_WEAK_THRESHOLD = 1000;
